import React, { Component } from 'react';
import NewUser from './newUser';
import ListUsers from './list';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ClipLoader from "react-spinners/ClipLoader";
import NoAccesComponent from '../../Shared/NoAccesComponent';
class Users extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      type: null,
      user: null,
      title: '',
      loading: true,
      canCreate: false,
      canEdit: false,
      canSee: false
    };
  }

  componentDidMount() {
    let permissions = window.localStorage.getItem('permissons');
    const userType = window.localStorage.getItem('userType');
    if(userType === 'ANALISTA') { 
      permissions = JSON.parse(permissions);
      let canCreate = false;
      let canEdit = false;
      let canSee = false;
      permissions[0].analyst.forEach(element => {
          if(element.name === 'see' && element.value === true){
            canSee = true;
          }
          if(element.name === 'create' && element.value === true){
            canCreate = true;
          }
          if(element.name === 'update' && element.value === true){
            canEdit = true;
          }
      });
      this.setState({canCreate:canCreate, canEdit:canEdit, canSee:canSee, loading:false});
    }else{
      this.setState({canCreate:true, canEdit:true, canSee:true, loading:false});
    }
  }

  openDialog = (type, user) => {
      if(!type) {
        return;
      }

      if(type === 'new' || type === 'update' || type === 'rules' ) {
        this.setState({open:!this.state.open, type, user});
      }

      if(type === 'new') {
        this.setState({title: 'Nuevo Funcionario'});
      }

      if(type === 'update') {
        this.setState({title: 'Actualizar informacion'});
      }

      if(type === 'rules') {
        this.setState({title: 'Actualizar Reglas'});
      }
    }

  closeDialog = () => {
    this.setState({loading:true, open:false});
    setTimeout(() => {
          this.setState({loading:false});
    }, 3000)  
  }
  
  render() {
        return (
          <div>
            {
              this.state.loading ? 
                <center>
                      <ClipLoader
                          color={'gray'}
                          loading={true}
                          size={50}
                          aria-label="Loading Spinner"
                          data-testid="loader"/>
                </center>
                :
                  <div>
                    {
                      this.state.canSee ? 
                        <ListUsers 
                          canCreate={this.state.canCreate}
                          canEdit={this.state.canEdit}
                          openDialog={(type, user)=> this.openDialog(type, user)}/>
                        :
                        <NoAccesComponent/>
                    }
                    
                      <Dialog open={this.state.open} onClose={()=>{console.log('closed')}} className="relative z-10">
                          <div className="fixed inset-0" />
                          <div className="fixed inset-0 overflow-hidden">
                            <div className="absolute inset-0 overflow-hidden">
                              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <DialogPanel
                                  transition
                                  className="pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                                >
                                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                    <div className="px-4 sm:px-6">
                                      <div className="flex items-start justify-between">
                                        <DialogTitle className="text-base font-semibold text-gray-900">
                                          {this.state.title}
                                        </DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                          <button
                                            type="button"
                                            onClick={() => this.setState({open:false, type:null})}
                                            className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                                          >
                                            <span className="absolute -inset-2.5" />
                                            <span className="sr-only">Close panel</span>
                                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                      {
                                        this.state.type === 'new' ? <NewUser closeDialog={() => this.closeDialog()}/> : null 
                                      }
                                      {
                                        this.state.type === 'update' ? <NewUser closeDialog={() => this.closeDialog()} user={this.state.user}/> : null
                                      }
                                    </div>
                                  </div>
                                </DialogPanel>
                              </div>
                            </div>
                          </div>
                      </Dialog>
                  </div>
            }
          </div>

        )
    }
}

export default Users;